import Vue from "vue";
import Vuex from "vuex";
import { } from './mutation-types'
import firebase from "firebase"
import "firebase/firestore"
import VueRouter from "vue-router";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    savers: []
  },
  mutations: {
    decrement(state, arg) {
      let saver = state.savers.find(s => s.id == arg.id)
      saver.saved += saver.step
    },
    addSaver(state, arg) {
      state.savers.push(arg.saver)
    },
    update(state, arg) {
      let saver = state.savers.find(s => s.id == arg.id)
      Object.assign(saver, arg)
    },
    deleteSaver(state, arg) {
      let saver = state.savers.find(s => s.id == arg.id)
      const index = state.savers.indexOf(saver);
      state.savers.splice(index, 1);
    }
  },
  actions: {
    risparmia({ commit, state }, arg) {
      let saver = state.savers.find(s => s.id == arg.id)
      firebase.firestore().collection("savers").doc(arg.id).update({ saved: saver.saved + saver.step })
        .then(function () {
          console.log("Document updated");
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
        });
        commit('decrement', arg)
    },
    init({ commit },arg) {
      firebase.firestore().collection("savers").where("userId","==",arg.uid).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          commit('addSaver', { saver: doc.data() })
        });
      });
    },
    updateSaver({ commit }, arg) {
      firebase.firestore().collection("savers").doc(arg.id).update(arg)
        .then(function () {
          console.log("Document updated");
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
        });
        commit('update', arg)
    },
    createSaver({ commit, dispatch }, arg) {
      firebase.firestore().collection("savers").add(arg)
        .then(function (docRef) {
          console.log("Document written with ID: ", docRef.id);
          arg.id = docRef.id
          arg.userId = firebase.auth().currentUser.uid
          return arg
        })
        .then(function(arg){
          dispatch('updateSaver',arg)
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
        commit('addSaver', {saver:arg})
    },
    deleteSaver({ commit }, arg) {
      firebase.firestore().collection("savers").doc(arg.id).delete().then(function () {
        console.log("Document successfully deleted!");
      }).catch(function (error) {
        console.error("Error removing document: ", error);
      });
      commit('deleteSaver',arg)
    },
    userSignOut(){
      firebase.auth().signOut()
      VueRouter.push('/')
    }
  },
  getters: {
    saverSet: (state) => state.savers
  }
});
